import { render, staticRenderFns } from "./statistic_stationed.vue?vue&type=template&id=3628516e&scoped=true"
import script from "./statistic_stationed.vue?vue&type=script&lang=js"
export * from "./statistic_stationed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3628516e",
  null
  
)

export default component.exports